import styled from '@emotion/styled';
import { spacing, mediaMin, fontSize } from 'presentations/views/styles';
import { blue02, white } from 'presentations/views/styles/color';
import StaticText from 'presentations/views/components/atoms/StaticText';
import Headline from 'presentations/views/components/atoms/Headline';
import Icon from 'presentations/views/components/atoms/Icon';

interface Props {
  title: string;
  content: string;
}

export default function Component(props: Props) {
  return (
    // <Container>
    <Box>
      <Title variant="h1">
        <Icon
          name="file-document-outline"
          size={fontSize(32)}
          color="primary"
        />
        <TitleDescription>{props.title}</TitleDescription>
      </Title>
      <StaticText body={props.content} />
    </Box>
    // </Container>
  );
}

const Title = styled(Headline)`
  text-align: center;
  margin-bottom: ${spacing(48)};
  display: flex;
  align-items: center;
`;

const TitleDescription = styled.span``;

const Box = styled.div`
  background-color: ${white};
  padding: ${spacing(24)};
  ${mediaMin.tablet} {
    padding: ${spacing(48)};
  }
`;
